//@ts-ignore
const CONTACT_FORM_ENDPOINT: string = process.env.REACT_APP_CONTACT_FORM_API_ENDPOINT;

type ContactUsFromProps = {
  name: string;
  lastName: string;
  fieldOfInterest: string;
  companyName: string;
  country: string;
  email: string;
  message: string;
  phone: string;
  token: string;
};

enum formType {
  BUSINESS_SOLUTION = 'Business Solutions',
  ACCESSIBILITY = 'Accessibility',
}

export const submitBusinessSolutionContactForm = async (formData: ContactUsFromProps) => {
  const formatedFormData = {
    Form_Type: formType.BUSINESS_SOLUTION,
    Name: formData.name,
    Last_Name: formData.lastName,
    Field_of_interest: formData.fieldOfInterest,
    Company_Name: formData.companyName,
    Country: formData.country,
    Email: formData.email,
    Phone: formData.phone,
    Message: formData.message,
    Token: formData.token,
  };
  return await fetch(`${CONTACT_FORM_ENDPOINT}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(formatedFormData),
  });
};

interface AccessibilityFormProps {
  email: string;
  message: string;
  token: string;
}

export const submitAccessibilityForm = async (formData: AccessibilityFormProps) => {
  const formatedFormData = {
    Form_Type: formType.ACCESSIBILITY,
    Email: formData.email,
    Message: formData.message,
    Token: formData.token,
  };

  try {
    const response = await fetch(`${CONTACT_FORM_ENDPOINT}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: JSON.stringify(formatedFormData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Error response:', response.status, data);
    }

    return data;
  } catch (error) {
    console.error('Network or parsing error:', error);
    throw error;
  }
};
